import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';

export interface RewashReasonPreset {
  slug: string;
  label: string;
}

export type RewashReasonPresetsResponse = ApiResponse<RewashReasonPreset[]> & {
  custom_reason_max_length: number;
};

export interface CreateRewashOrderPayload {
  /**
   * Exactly one of original_order_id, original_subscription_wash_id or (CWS-1882)
   * original_prepaid_redemption_id — a redeemed prepaid wash has no order of its own.
   */
  original_order_id?: string;
  original_subscription_wash_id?: string;
  original_prepaid_redemption_id?: string;
  rewash_reason: string;
  /** Lane resolved from the camera event, as for POST /order. */
  lane_id?: string;
}

export interface CreateRewashOrderResult {
  order: Record<string, any>;
  /** For a prepaid rewash this is the PURCHASE order the visit belongs to. */
  original_order_id: string;
  original_subscription_wash_id?: string;
  original_prepaid_redemption_id?: string;
  created: boolean;
}

@Injectable({ providedIn: 'root' })
export class RewashReasonService {
  constructor(private readonly api: ApiService) {}

  getRewashReasonPresets(): Observable<RewashReasonPresetsResponse> {
    return this.api.get<RewashReasonPreset[]>(
      'order/rewash-reason-presets'
    ) as Observable<RewashReasonPresetsResponse>;
  }

  createRewashOrder(
    payload: CreateRewashOrderPayload
  ): Observable<ApiResponse<CreateRewashOrderResult>> {
    return this.api.post<CreateRewashOrderResult>('order/rewash', payload);
  }
}
